/** @format */

import {AccountsKpiName} from 'graphql/generated/types';

import {DailyStat} from '../pages/Home/Main/Project/components/Campaigns/types';
import {CampaignCardData} from '../pages/Home/Main/Project/components/Campaigns/components/CampaignCards';
import {
  KPI_DISPLAY_NAMES,
  LOWER_IS_BETTER_KPI,
  GRID_COLUMNS_BY_COUNT,
} from '../pages/Home/Main/Project/components/Campaigns/components/CampaignCards/constants';

const DEFAULT_GRID_COLUMNS = 3;

export const buildCumulativeSpentChart = (
  dailyStats: ReadonlyArray<DailyStat>,
): {name: string; amount: number}[] => {
  let accumulated = 0;

  return dailyStats.map((stat, index) => {
    accumulated += stat.spent;
    return {
      name: `${index + 1}`,
      amount: Math.round(accumulated),
    };
  });
};

export const getKpiDisplayName = (kpiName: AccountsKpiName): string => {
  return KPI_DISPLAY_NAMES[kpiName] || kpiName;
};

export const isLowerBetter = (kpiName: AccountsKpiName): boolean => {
  return LOWER_IS_BETTER_KPI.includes(kpiName);
};

export const getGridColumns = (count: number): number => {
  return GRID_COLUMNS_BY_COUNT[count] ?? DEFAULT_GRID_COLUMNS;
};

export const sortCampaignsBySpent = (campaigns: CampaignCardData[]): CampaignCardData[] => {
  return [...campaigns].sort((a, b) => b.spent - a.spent);
};

